import styled, { css } from 'styled-components';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const StyledButton = styled.button`
  cursor: pointer;
  display: inline-block;
  margin: 0;
  padding: 6px 12px;
  border: none;
  border-radius: 3px;
  box-shadow: none;
  outline: 0;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  ${() =>
    !isOmp &&
    css`
      letter-spacing: 1.03px;
    `}

  text-transform: ${({ theme }) => !isOmp && theme.BUTTON.TEXT_TRANSFORM};
  text-align: center;
  ${props => props.css}

  ${() =>
    isOmp &&
    css`
      letter-spacing: 0;
    `}
`;

export const StyledButtonPrimary = styled(StyledButton)`
  background: ${({ theme }) => theme.COLORS.TERTIARY};
  color: ${({ theme }) => theme.COLORS.BASE};
  border: solid 2px ${({ theme }) => theme.COLORS.TRANSPARENT};

  &:hover {
    background: ${({ theme }) => theme.COLORS.DARK_BLUE};
  }
`;

export const StyledButtonSecondary = styled(StyledButton)`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  border-radius: 3px;
  border: solid 2px ${({ theme }) => theme.COLORS.BASE_INVERTED};
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  height: max-content;

  &:hover {
    color: ${({ theme }) => theme.COLORS.DARK_BLUE};
    border: 2px solid ${({ theme }) => theme.COLORS.DARK_BLUE};

    ${() =>
      isOmp &&
      css`
        background-color: ${({ theme }) => theme.COLORS.WHITE_LILAC};
      `}
  }
`;

export const StyledButtonBorderless = styled(StyledButton)`
  border: none;
  outline: none;
`;

export const StyledButtonTransparent = styled(StyledButtonBorderless)`
  background: transparent;
`;

const labelVariants = {
  unselected: css`
    background-color: ${({ theme }) => theme.COLORS.BASE};
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    letter-spacing: 0;
  `,
  selected: css`
    background-color: ${({ theme }) => theme.COLORS.TERTIARY};
    color: ${({ theme }) => theme.COLORS.BASE};
  `
};

export const StyledButtonControlled = styled(StyledButton)`
  width: 100%;
  text-align: center;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.DEEP_GREY};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  ${props => labelVariants[props.variant]};
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: 0px;
  text-transform: none;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;
